import { request } from "util/api/client";
import { takeEvery, put, select } from "redux-saga/effects";
import { pending } from "state/actions/ui";
import { handleResponse } from "state/sagas/api";
import { selectEntity } from "state/selectors/data";
import { reload } from "state/actions/list";

function* handleSyncIntegrationTags({ context, payload }) {
    const { id, apply } = payload;
    try {
        yield put(pending(id, true));
        const url = apply
            ? `cms/integrations/${id}/sync-tags`
            : `cms/integrations/${id}/sync-tags-status`;
        const integration = yield select((store) =>
            selectEntity(store, "cms.integrations", id)
        );
        const data = {};
        if (integration.project_id) data.project_id = integration.project_id;
        if (integration.tags_entry_types)
            data.tags_entry_types = integration.tags_entry_types;
        const response = yield request({
            method: "post",
            url,
            context,
            data,
        });
        yield handleResponse(payload, response);
        yield put(pending(id, false));
    } catch (e) {
        yield put(pending(id, false));
    }
}

function* handleUpdateConfiguration({ context, payload }) {
    const { id } = payload;
    try {
        yield put(pending(id, true));
        const url = `cms/integrations/${id}/update-config`;
        const response = yield request({
            method: "post",
            url,
            context,
        });
        yield put(pending(id, false));
    } catch (e) {
        yield put(pending(id, false));
    }
}

function* handleSyncData({ context, payload }) {
    const { id } = payload;
    try {
        yield put(pending(id, true));
        const url = `cms/integrations/${id}/sync-data`;
        const response = yield request({
            method: "post",
            url,
            context,
        });
        // keep behaviour consistent with handleUpdateConfiguration (no handleResponse)
        yield put(pending(id, false));
    } catch (e) {
        yield put(pending(id, false));
    }
}

function* handleRunSyncTask({ context, payload }) {
    const { id, type } = payload;
    try {
        yield put(pending(id, true));
        const url = `cms/sync-tasks/${id}/run`;
        const response = yield request({
            method: "post",
            url,
            context,
        });
        // keep behaviour consistent with handleUpdateConfiguration (no handleResponse)
        yield put(pending(id, false));
        if (type) yield put(reload(context)(type, type));
    } catch (e) {
        yield put(pending(id, false));
    }
}

export default function* () {
    yield takeEvery("CMS.INTEGRATIONS.SYNC_TAGS", handleSyncIntegrationTags);
    yield takeEvery(
        "CMS.INTEGRATIONS.UPDATE_CONFIGURATION",
        handleUpdateConfiguration
    );
    yield takeEvery("CMS.INTEGRATIONS.SYNC_DATA", handleSyncData);
    yield takeEvery("CMS.INTEGRATIONS.SYNC_TASK_RUN", handleRunSyncTask);
}
